import { TemplateResourceContextProps } from '@/types/template-resource';
import { createContext, useContext } from 'react';


export const TemplateResourceContext = createContext<TemplateResourceContextProps|undefined>(undefined);

export const useTemplateResourceContext = () => {
	const templateResource = useContext(TemplateResourceContext);

	if (templateResource === undefined) {
		throw new Error('useTemplateResourceContext must be used within a TemplateResourceProvider');
	}

	return templateResource;
}